import React from 'react';
import { Cushion, Rectangle, Grid, GridItem, Typography, Space } from '@pitchero/react-ui';
import LoginButton from '../../auth/login-button';
import { Trans } from '../../../lib/i18n';

const LoginNotice = () => (
  <Cushion all="medium" responsive={[{ minWidth: 'tab', props: { vertical: 'medium' } }]}>
    <Rectangle fill="mercury" radius="rounded">
      <Grid rowGap="xsmall" responsive={[{ minWidth: 'lap', props: { columns: '1fr auto' } }]}>
        <GridItem>
          <Typography preset="subtitle--small" component="div">
            <Trans i18nKey="shop:login_to_buy_product_title">
              Only assigned members can buy this product
            </Trans>
          </Typography>
          <Space
            vertical="small"
            responsive={[{ minWidth: 'lap', props: { bottom: 'xxsmall', top: 'xsmall' } }]}
          >
            <Typography preset="description" color="dovegrey" component="div">
              <Trans i18nKey="shop:login_to_buy_product_subtitle">
                Login to view your assigned products
              </Trans>
            </Typography>
          </Space>
        </GridItem>
        <GridItem alignSelf="center">
          <LoginButton translationKey="shop:login_to_buy_product_button_text" compact />
        </GridItem>
      </Grid>
    </Rectangle>
  </Cushion>
);

export default LoginNotice;
